function triggerFunFilters(e){
    e.preventDefault();
}
function clearAllFunFilters(){
    let funFilterRadios = document.querySelectorAll('.fun-filter--radio');
    funFilterRadios.forEach( radio => {
        let val = radio.value;
        if( val.includes('v.price') ){
            if( document.getElementById('Filter-Price-LTE') && document.getElementById('Filter-Price-LTE') != '' ){
                document.getElementById('Filter-Price-LTE').value = '';
            }
            if( document.getElementById('Filter-Price-GTE') && document.getElementById('Filter-Price-GTE') != '' ){
                document.getElementById('Filter-Price-GTE').value = '';
            }
        }
        if( val.includes('p.tag') || val.includes('p.product_type') ){
            let tag = val.split('=')[1];
            let tag_unescaped;
            if( tag ){
                tag_unescaped = unescape(tag);
            }
            if( document.querySelector('input[value="'+tag_unescaped+'"]') && document.querySelector('input[value="'+tag_unescaped+'"]').hasAttribute('checked') ){
                document.querySelector('input[value="'+tag_unescaped+'"]').removeAttribute('checked');
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", function() {
    let funFilterRadios = document.querySelectorAll('.fun-filter--radio');
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    funFilterRadios.forEach( radio => {
        // In some contexts (e.g.: Canada market), the price range filter is not available
        if (radio.value.includes('filter.v.price')) {
            const hasInvalidLte = radio.value.includes('.lte') && !document.getElementById('Filter-Price-LTE');
            const hasInvalidGte = radio.value.includes('.gte') && !document.getElementById('Filter-Price-GTE');
            const shouldHideRadioAndLabel = hasInvalidLte || hasInvalidGte;

            radio.hidden = shouldHideRadioAndLabel;
            radio.parentElement.querySelector(`[for="${radio.id}"]`).hidden = shouldHideRadioAndLabel;
        }

        radio.addEventListener('change', (event)=> {
            clearAllFunFilters();
            let new_filter = event.target.value;
            if( new_filter == '[[ALL]]' || new_filter == 'ALL') {
                document.getElementById('Filter-Price-LTE').dispatchEvent(new Event("input", { bubbles: true }));   
            }

            if( new_filter.includes('v.price') ){
                let amount = new_filter.split('=')[1];
                if( new_filter.includes('.lte') && document.getElementById('Filter-Price-LTE') ) {
                    document.getElementById('Filter-Price-LTE').value = amount;
                    document.getElementById('Filter-Price-LTE').dispatchEvent(new Event("input", { bubbles: true }));
                }
                if( new_filter.includes('.gte') && document.getElementById('Filter-Price-GTE') ) {
                    document.getElementById('Filter-Price-GTE').value = amount;
                    document.getElementById('Filter-Price-GTE').dispatchEvent(new Event("input", { bubbles: true }));
                }
            }
            if( new_filter.includes('p.tag') || new_filter.includes('p.product_type') ){
                let tag = new_filter.split('=')[1];
                let tag_unescaped;
                if( tag ){
                    tag_unescaped = unescape(tag);
                }
                document.querySelector('input[value="'+tag_unescaped+'"]').checked = true;
                // Override to ensure the filter value is passed through, as it sometimes is disabled by the previously active filter, and the formData discard disabled inputs
                document.querySelector('input[value="'+tag_unescaped+'"]').disabled = false;
                document.querySelector('input[value="'+tag_unescaped+'"]').dispatchEvent(new Event("input", { bubbles: true }));
            }
        });

        for (const [key, value] of Object.entries(params)) {
            let radio_items = radio.value.split('=');
            let decodedValue = value.includes('gid://') ? decodeURIComponent(radio_items[1]) : radio_items[1];
            if( value == decodedValue && key == radio_items[0] ){
                radio.click();
            }
        }
    });
});